import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  property: belongsTo('zone'),
  location: belongsTo('location'),
  suites: hasMany('zone'),
  tenantConnectionRequest: belongsTo('tenant-connection-request'),
  tenantPermissionsConfiguration: belongsTo('tenant-permissions-configuration'),
});
